// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuetify from 'vuetify';
import Vuex from 'vuex';
import Cookie from 'vue-cookie';
import Resource from 'vue-resource';
import Datetime from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';

import App from './App';
import router from './router';
import store from './store';

Vue.use(Vuetify, {
  theme: {
    primary: '#00838f',
    secondary: '#00838f',
    accent: '#f57f17',
    error: '#e65100',
    info: '#2196F3',
    success: '#4CAF50',
    warning: 'yellow darken-4',
  },
});
Vue.config.productionTip = false;
import('~/vuetify/dist/vuetify.min.css');

Vue.use(Datetime);

Vue.use(Resource);
Vue.http.options.root = process.env.NODE_ENV === 'production' ? '/api/v1' : 'http://localhost:3000/api/v1';

Vue.use(Vuex);

Vue.use(Cookie);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: store(),
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js